import HeroSection from '../components/HomePage/HeroSection';
import OurServices from '../components/HomePage/OurServices';
import WhyChooseUs from '../components/HomePage/WhyChooseUs';
import ClientsSection from '../components/HomePage/ClientsSection';
import UnderConsruction from '../components/UnderConsruction';

export default function HomePage() {
    return (
        <div className="pb-4 sm:pb-8 bg-gray-50">
            {/* <UnderConsruction /> */}
            <HeroSection />
            <OurServices />
            <ClientsSection />
            <WhyChooseUs />
        </div>
    );
}
